module.exports = {
    body_min_height:{
        desktop:'600px',
    },
    noRecordFound:'No Record Found',
    showDeleteOption: false
}